import { NegotiationImpossibleCase, ProcedureType } from "../../autogen/bff-api";

export const isNegotiationWithoutNotice = (procedureType: ProcedureType | null | undefined): boolean =>
  procedureType === ProcedureType.NegotiatedWithoutPriorCall;

// Mirrors NegotiationImpossibleCase.followsFailedCompetition in the BFF: FOA § 13-3 a and b.
export const followsFailedCompetition = (value: NegotiationImpossibleCase | null | undefined): boolean =>
  value === NegotiationImpossibleCase.OnlyUnacceptableTenders || value === NegotiationImpossibleCase.NoSuitableTenders;

// FOA § 13-3 a: everyone who tendered in the failed competition, and only they, are invited.
export const invitesPrecedingTenderers = (value: NegotiationImpossibleCase | null | undefined): boolean =>
  value === NegotiationImpossibleCase.OnlyUnacceptableTenders;

// FOA § 13-3 d / forsyningsforskriften § 9-2 c: every winner of the design contest, and only they, are invited.
export const followsDesignContest = (value: NegotiationImpossibleCase | null | undefined): boolean =>
  value === NegotiationImpossibleCase.DesignContestWinners;

// Mirrors ProcedureType.awardsWithoutPriorPublication in the BFF: only these can carry an intention notice.
export const awardsWithoutPriorPublication = (procedureType: ProcedureType | null | undefined): boolean =>
  procedureType === ProcedureType.WithoutCompetition || procedureType === ProcedureType.NegotiatedWithoutPriorCall;
